import script from "./AdminOrderInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminOrderInfo.vue?vue&type=script&setup=true&lang=js"

import "./AdminOrderInfo.vue?vue&type=style&index=0&id=5bc53446&lang=scss&scoped=true"

import exportComponent from "/home/ecs-user/software/jenkins/workspace/smallshop-website-uat/smallshop-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bc53446"]])

export default __exports__